// lib/mock/index.ts
export * from "./products";
export * from "./orders";
export * from "./users";
export * from "./coupons";
export * from "./support";
export * from "./dashboard";